module.exports = __webpack_public_path__ + "img/40_38_068_730.a4644a99.jpg";